import React, { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../context/loginContext.js';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import axios from 'axios';
import { message, Card } from 'antd';

const Home = () => {
  const { user, logout } = useContext(LoginContext);
  const [historial, setHistorial] = useState(null);

  // Función para obtener el historial de movimientos
  const fetchHistorial = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${user.token}`,
      };
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/historial/chart`, { headers });
      setHistorial(response.data);
    } catch (error) {
      message.error('Error al obtener el historial de movimientos');
    }
  };

  useEffect(() => {
    fetchHistorial();
  }, []);

  if (!historial) return <div>Loading...</div>;

  // Configuración de datos para el gráfico de barras
  const chartData = {
    labels: historial.movimientos.map((mov) => mov.tipoMovimiento),
    datasets: [
      {
        label: 'Cantidad de Movimientos',
        data: historial.movimientos.map((mov) => mov.count),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 1 },
      },
    },
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px' }}>

      <Card
        style={{
          marginTop: '10px',
          width: '100%',
          maxWidth: '400px',
          textAlign: 'center',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        }}
        bordered
      >
        <h2>Posiciones Ocupadas</h2>
        <p style={{ fontSize: '30px', fontWeight: 'bold', margin: '0' }}>{historial.posicionesOcupadas}</p>
      </Card>
      
      <div style={{ width: '100%', maxWidth: '700px', marginTop: '15px' }}>
        <h2 style={{ textAlign: 'center' }}>Movimientos</h2>
        <div style={{ height: '300px' }}>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </div>
  );
};

export default Home;